import { constants as config } from '@config';

const ImagesFactory = require('../../../factory/images');

const GraphicCreator = require('./abstract/graphic');
const LogoCreator = require('./logo');

module.exports = IconCreator;

function IconCreator () {}
IconCreator.prototype = new GraphicCreator();
IconCreator.prototype.constructor = IconCreator;

IconCreator.prototype.create = function (data) {
  if (!data.is_vector && data.resize !== false) data.thumb_src = ImagesFactory.getVersionUrl(data.thumb_src, 'thumb');
  if (data.svg_url && !data.svg_url.endsWith('.svg')) data.thumb_src = ImagesFactory.getVersionUrl(data.svg_url, 'thumb');

  const element = this._createIconContainer(data);
  const triggerEvent = _.bind(function () {
    this.trigger('', element.getAttribute('id'));
  }, this);

  if (data.is_vector) {
    data.content || this.fetchContent(element, data);
    data.content && this.updateContent(element, data);
    this.once('content', triggerEvent);
  } else {
    this._smartImageLoad(element, data);
    this.once('resolution_optimized', triggerEvent);
  }

  this.canvas.selectOnly([element]);

  return element.getAttribute('id');
};

IconCreator.prototype._createIconContainer = function (data) {
  const attr = {
    id: this.canvas.getNextId(),
    class: 'element icon'
  };

  if (data.smart_asset) {
    attr[config.smartAssets.attributes.definedAsset] = data.smart_asset;
    attr[config.smartAssets.attributes.definedContentType] = config.smartAssets.typeToProperty.icons;
  }

  const logo = this.canvas.addSvgElementFromJson({ element: 'g', attr });
  const richData = this.getAddData(data);
  this._appendImageIcon(logo, richData);

  richData.smart_asset && INKIVE.ImagesFactory.addBBoxValues(logo);

  return logo;
};

IconCreator.prototype.initialize = LogoCreator.prototype.initialize;
IconCreator.prototype.updateContent = LogoCreator.prototype.updateContent;
IconCreator.prototype._smartImageLoad = LogoCreator.prototype._smartImageLoad;
IconCreator.prototype.fetchContent = LogoCreator.prototype.fetchContent;
IconCreator.prototype._appendImageIcon = LogoCreator.prototype._appendImageLogo;
IconCreator.prototype.getAddData = LogoCreator.prototype.getAddData;
